import React     from 'react';
import PropTypes from 'prop-types'

import PriceMatrixTitle from './price_combined/PriceMatrixTitle';
import PriceMatrix      from './price_combined/PriceMatrix';
import Parameters       from './price_combined/Parameters';
import Notes            from './price_combined/Notes';

const PriceCombined = (props) => {
  const { quote, showSummary, parameters } = props
  // if empty quote or empty us combined dont show matrix
  if (!quote || !quote.line_items || !quote.us_line_item_combined) return null

  const usCombined = quote.us_line_item_combined
  const parametersCustomer = extracParameteres(quote, '-grpb')
  const parametersBestPrice = extracParameteres(quote, '-grpa')

  if (showSummary && parameters.supplier_selected.indexOf('offshore') > 0) return null;

  return (
    <div className="price-combined mb-4">
      <PriceMatrixTitle
        parametersCustomer={parametersCustomer}
        quoteStep={props.quoteStep} />
      <PriceMatrix
        usCombined={usCombined}
        quoteStep={props.quoteStep}
        parameters={props.parameters}
        parametersChanged={props.parametersChanged}
        onPriceSelect={props.onPriceSelect}
        showSummary={showSummary} />
      <Parameters
        usCombined={usCombined}
        parametersCustomer={parametersCustomer}
        parametersBestPrice={parametersBestPrice}
        showSummary={showSummary} />
      {!showSummary && <Notes /> }
    </div>
  );
};

/**
 * Extract parameters from line item where the quote_config key match by sufix
 */
const extracParameteres = (quote, sufix) => {
  if (!quote || !quote.line_items) return null;

  const find = quote.line_items.find(li => _.endsWith(li.quote_config_key, sufix))
  return find ? find.options : null;
}

PriceCombined.propTypes = {
  parameters: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  quoteStep: PropTypes.string.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  showSummary: PropTypes.bool.isRequired,
}

export default PriceCombined
